import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import Navbar from '@/pages/Navbar/Navbar';

// ✅ Itens do menu SEM controle por "permitidos"
const menuItems = [
  { id: 1, name: "Agendamentos", icon: "/icons/agendamentos.png", path: "/agendamentos" },
  { id: 2, name: "Formulario", icon: "/icons/cadastro.png", path: "/formulario" },
];

const Painel = () => {
  const { authUser } = useAuth();
  const navigate = useNavigate();

  if (!authUser || authUser.acesso === "n") {
    return (
      <p className="text-red-600 font-medium text-center mt-6">
        Acesso negado. Você não tem permissão para visualizar esta página.
      </p>
    );
  }

  return (
    <>
      <Navbar />
      <style>
        {`
          .hover-bounce {
            transition: transform 0.3s ease;
          }
          .painel-card:hover .hover-bounce {
            transform: scale(1.08) rotate(3deg);
          }
        `}
      </style>

      <div className="min-h-screen bg-white py-10 px-4 text-gray-800">
        <h2 className="text-xl text-center mb-2 text-[#6b5843] font-medium">
          Olá, Bem-vindo{authUser?.nome ? ` ${authUser.nome}` : ""}!
        </h2>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-10 font-serif text-[#caa874] drop-shadow-sm">
          Painel de Controle
        </h1>

        <div className="max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {menuItems.map((item) => {
            if (item.adminOnly && authUser.adm !== "s") return null;

            return (
              <div
                key={item.id}
                className="painel-card bg-gradient-to-tr from-white to-[#f9f7f3] border border-[#e7e3da] rounded-2xl shadow-md hover:shadow-lg transition-all cursor-pointer p-4 flex flex-col items-center justify-center"
                onClick={() => navigate(item.path)}
              >
                <img
                  src={item.icon}
                  alt={item.name}
                  className="w-10 h-10 sm:w-12 sm:h-12 mb-3 hover-bounce"
                />
                <p className="text-center text-sm sm:text-base font-semibold text-[#5b5242]">
                  {item.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Painel;
